// @flow

import * as React from 'react';
import { Link } from 'react-router';

import Icon from 'app/components/shared/Icon';

type Props = {
  children: React.Node,
  to?: string,
  href?: string,
  onClick?: (event: SyntheticEvent<HTMLAnchorElement>) => void
};

export default class RowLink extends React.PureComponent<Props> {
  static displayName = "Panel.RowLink";

  render() {
    if (this.props.to) {
      return (
        <Link to={this.props.to} className="btn py2 px3 flex items-center hover-bg-silver hover-black focus-black">
          <div className="flex-auto">
            {this.props.children}
          </div>
          <Icon icon="chevron-right" className="flex-none dark-gray" style={{ height: 15, width: 15 }} />
        </Link>
      );
    }

    return (
      <a href={this.props.href} onClick={this.props.onClick} className="btn py2 px3 flex items-center hover-bg-silver hover-black focus-black">
        <div className="flex-auto">
          {this.props.children}
        </div>
        <Icon icon="chevron-right" className="flex-none dark-gray" style={{ height: 15, width: 15 }} />
      </a>
    );
  }
}
